/* ==========================================================================
   LOREN KADI — Landings de conversion : révélation au scroll
   Fichier NEUF. Partagé par toutes les pages bâties sur .lk-landing.

   Extrait le 26/08/2026 du bloc « Liquide personnalisé » du modèle
   formation-landing, où il vivait en double avec page.headspa.liquid.

   --------------------------------------------------------------------------
   CE QUI EST ICI : uniquement ce qui est commun à toutes les landings.
   Le simulateur de revenus reste dans la page : ses chiffres (coût de la
   formation, coûts par soin) diffèrent d'une landing à l'autre.

   APPEL depuis le bloc Liquide personnalisé, en fin de bloc :
     <script src="{{ 'component-landing-lk.js' | asset_url }}" defer></script>

   COMPORTEMENT : les éléments listés dans SELECTEURS reçoivent la classe
   .reveal, puis .is-visible dès qu'ils entrent dans le champ de vision.
   Le style correspondant est dans component-landing-lk.css.

   RESPECT DE L'UTILISATEUR : si le système est réglé sur « réduire les
   animations », le script ne fait rien du tout — les blocs restent
   simplement visibles. C'est voulu, ne pas « corriger ».
   ========================================================================== */

(function () {
  'use strict';

  var SELECTEURS = [
    '.hero-content',
    '.pq-item',
    '.signature-inner',
    '.kit-inner > div',
    '.prog-header',
    '.prog-item',
    '.prog-chiffre',
    '.sim-inner',
    '.comp-inner',
    '.tarif-item',
    '.tarif-card',
    '.faq-item',
    '.cta-final-inner'
  ].join(', ');

  /* Décalage en cascade à l'intérieur d'un groupe : les éléments d'une même
     rangée n'apparaissent pas tous en même temps. Le plafond évite qu'un
     vingtième élément attende deux secondes. */
  var CASCADES = [
    { selecteur: '.pq-item',      pas: 70, plafond: 3 },
    { selecteur: '.prog-item',    pas: 35, plafond: 9 },
    { selecteur: '.prog-chiffre', pas: 60, plafond: 4 },
    { selecteur: '.tarif-item',   pas: 45, plafond: 8 },
    { selecteur: '.faq-item',     pas: 60, plafond: 4 }
  ];

  function init() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var racine = document.querySelector('.lk-landing');
    if (!racine || !('IntersectionObserver' in window)) return;

    var cibles = Array.prototype.slice.call(racine.querySelectorAll(SELECTEURS));
    if (!cibles.length) return;

    CASCADES.forEach(function (groupe) {
      Array.prototype.forEach.call(
        racine.querySelectorAll(groupe.selecteur),
        function (el, i) {
          el.style.transitionDelay = (Math.min(i, groupe.plafond) * groupe.pas) + 'ms';
        }
      );
    });

    cibles.forEach(function (el) { el.classList.add('reveal'); });

    var observateur = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible');
          observateur.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -7% 0px' });

    cibles.forEach(function (el) { observateur.observe(el); });
  }

  /* Appelé avec defer, le DOM est déjà analysé. Le test reste là au cas où le
     script serait un jour chargé autrement. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();